export default __webpack_public_path__ + "static/media/Mobile.8a941747.png";